/**
 * Component Product SKU
 * 
 * @module product-sku
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'product-sku';

 if (!customElements.get(customElements.component)) {

    class productSku extends HTMLElement {
 
        /**
         * Product SKU web component.
         * 
         * @constructor
         */
        constructor() {

            super();
        
            this.initEvents();
        }

        /**
         * Init module
         */
        initEvents()  {
            window.addEventListener('variant-change', this.onVariantChange.bind(this));
        }

        onVariantChange(event) {
            this.innerHTML = event.detail.variant.sku;
        }

    }

    customElements.define(customElements.component, productSku);
}


